import React, { useEffect, useState } from 'react';
import { Box, Text } from '@chakra-ui/react';
import Taskbar from './Taskbar';

export const Desktop = ({ redux, ui, children }) => {
  const { setActiveWindowAction } = redux,
    { windows, activeWindow } = ui;
  const [tvMessage, showTvMessage] = useState(true);
  let pJSON = require('../../../package.json');
  useEffect(() => {
    setTimeout(() => {
      showTvMessage(false);
    }, 3000);
  });
  return (
    <>
      <Box
        className={'crt--'}
        position={'fixed'}
        w={'100vw'}
        h={'100vh'}
        zIndex={20000}
        pointerEvents={'none'}
        bgImg={
          'linear-gradient(0deg, #ffffff11 25%, #00000011 25%, #00000011 50%, #ffffff11 50%, #ffffff11 75%, #00000011 75%, #00000011 100%);'
        }
        backgroundSize={'6.00px 6.00px'}
      />
      <Box bgImg={'Sandstone.bmp'} w={'100vw'} h={'100vh'}>
        {tvMessage && (
          <Text
            color={'#00FF66'}
            position={'fixed'}
            zIndex={10000}
            left={35}
            top={30}
            fontSize={60}
            pointerEvents={'none'}
          >
            АНАЛОГ
          </Text>
        )}
        {children}
        <Taskbar
          pJSON={pJSON}
          windows={windows}
          activeWindow={activeWindow}
          setActiveWindow={setActiveWindowAction}
        />
      </Box>
    </>
  );
};

export default Desktop;
